export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/mm.26705b19.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};